import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import { themeColor } from '../Theming';
import images from '../Theming/images';

const SubTitleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`;

const SubTitleText = styled.div`
  color: ${themeColor('darkestGrey')};
  text-align: center;
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  width: 220px;
`;

const LinkText = styled.a`
  color: ${themeColor('blue')};
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 100%;
  margin-top: 33px;
  margin-top: 33px;
  padding-left: 24px;
  padding-right: 24px;
`;

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
`;

const StyledImage = styled.img`
  margin-top: 5px;
`;

const IconContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 23px;
`;

const IconContentDescription = styled.div`
  color: ${themeColor('darkestGrey')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding-top: 15px;
`;

const WhatYouNeedText = styled.div`
  font-family: Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20.8px;
  margin-bottom: 11px;
`;

const ContentItem = styled.div`
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 39px;
  width: 250px;
  display: flex;
  flex-direction: row;
`;

const AllowBothText = styled.div`
  width: 170px;
  padding-left: 4px;
`;

const PartnerNewPluginActivateMultiStepPartialPermissions = () => {
  const { t } = useTranslation();

  return (
    <MultiStepActivationContainer
      headerText={
        'PartnerNewpluginsdkActivate.onlyPartiallyInstalledHeaderText'
      }
      bodyMarginTop={-5}
    >
      <SubTitleTextContainer>
        <SubTitleText>
          <Trans
            t={t}
            i18nKey={'PartnerNewpluginsdkActivate.weCantMatchDiscounts'}
          >
            <LinkText>AbsoluteText</LinkText>
          </Trans>
        </SubTitleText>
      </SubTitleTextContainer>
      <BodyContentContainer>
        <WhatYouNeedText>
          {t('PartnerNewpluginsdkActivate.hereWhatYouNeed')}
        </WhatYouNeedText>
        <IconContentContainer>
          <IconContentDescription>
            <ContentItem>
              1. {t('PartnerNewpluginsdkActivate.gotToSettings')}
            </ContentItem>
            <ContentItem>
              2. {t('PartnerNewpluginsdkActivate.tapSafari')}
            </ContentItem>
            <ContentItem>
              3. {t('PartnerNewpluginsdkActivate.scrollDownToExtensions')}
            </ContentItem>
            <ContentItem>
              4. {t('PartnerNewpluginsdkActivate.selectItvX')}
            </ContentItem>
            <ContentItem>
              5.
              <AllowBothText>
                {t('PartnerNewpluginsdkActivate.allowBothWebsites')}
              </AllowBothText>
            </ContentItem>
          </IconContentDescription>
          <StyledImage
            src={images.partnerpluginsdk_safari_settings_steps?.default}
            width={40}
            height={258.4}
            alt="activationSteps"
          />
        </IconContentContainer>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerNewPluginActivateMultiStepPartialPermissions;
